module.exports = __webpack_public_path__ + "img/catchbasin_parked.6dc58d03.svg";